import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  spinnings:false,
	  loadingClose:false,
	  menuKeys:'',
	  userData:'',
	  userList:'',
	  userMsg:''
  },
  mutations: {
	  updateSpin(state,num){
		  state.spinnings=num
	  },
	  updateClose(state,num){
	  		  state.loadingClose=num
	  },
	  updateMenuKeys(state,num){
	  		  state.menuKeys=num
	  },
	  updateUserData(state,num){
	  		  state.userData=num
	  },
	  updateUserList(state,num){
	  		  state.userList=num
	  },
	  updateUserMsg(state,num){
		state.userMsg=num
}
  },
  actions: {
  },
  modules: {
  }
})
